import type { NWordSortField, NWordSummary } from '@/types/nWords';

export const WORD_LENGTHS = [1, 2, 3, 4, 5] as const;

export const N_WORD_COLUMNS: ReadonlyArray<{ id: NWordSortField; label: string }> = [
  { id: 'phrase', label: 'N-word' },
  { id: 'wordCount', label: 'Words' },
  { id: 'frequency', label: 'Frequency' },
  { id: 'impressions', label: 'Impressions' },
  { id: 'clicks', label: 'Clicks' },
  { id: 'spend', label: 'Spend' },
  { id: 'sales', label: 'Sales' },
  { id: 'orders', label: 'Orders' },
  { id: 'acos', label: 'ACOS' },
  { id: 'roi', label: 'ROI' },
  { id: 'cvr', label: 'CVR' },
  { id: 'ctr', label: 'CTR' },
  { id: 'cpc', label: 'CPC' },
  { id: 'cpo', label: 'CPO' },
];

export const WORD_LENGTH_COLORS = ['#3B82F6', '#22C55E', '#EAB308', '#F97316', '#A855F7'] as const;

export function wordLengthLabel(wordCount: number): string {
  return `${wordCount}-word`;
}

export function sharePercents(values: number[]): number[] {
  const total = values.reduce((sum, value) => sum + (Number.isFinite(value) ? value : 0), 0);
  if (total <= 0) return values.map(() => 0);
  return values.map((value) => ((Number.isFinite(value) ? value : 0) / total) * 100);
}

export function metricShares(summary: NWordSummary[]): {
  sales: number[];
  spend: number[];
  clicks: number[];
} {
  const byCount = new Map(summary.map((row) => [row.wordCount, row]));
  const sales: number[] = [];
  const spend: number[] = [];
  const clicks: number[] = [];
  for (const wordCount of WORD_LENGTHS) {
    const row = byCount.get(wordCount);
    sales.push(row?.sales ?? 0);
    spend.push(row?.spend ?? 0);
    clicks.push(row?.clicks ?? 0);
  }
  return {
    sales: sharePercents(sales),
    spend: sharePercents(spend),
    clicks: sharePercents(clicks),
  };
}
